import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AppConfig } from 'src/app/app.config';
import { LatLng } from 'leaflet';
import { environment } from 'src/environments/environment';

export class StreetViewModalState {
  // @ts-ignore
  location: google.maps.LatLng;
  pano: string;
  pov: { heading: number, pitch: number, zoom: number };

  // @ts-ignore
  constructor(location: google.maps.LatLng, pano: string, pov: any) {
    this.location = location;
    this.pano = pano;
    this.pov = pov;
  }
}

@Component({
  selector: 'app-street-view-modal',
  templateUrl: './street-view-modal.component.html',
  styleUrls: [ './street-view-modal.component.scss' ]
})
export class StreetViewModalComponent implements OnInit, AfterViewInit {

  @Input() public data;
  @Input() public disabled = false;
  @Input() public inserting = false;
  @Input() public images = [];

  @Output() public addImageChange = new EventEmitter();
  @Output() public closeChange = new EventEmitter();

  @ViewChild('viewContainer', { static: false })
  public viewContainer;

  // @ts-ignore
  private panorama: google.maps.StreetViewPanorama;

  constructor(
    public activeModal: NgbActiveModal,
    private appConfig: AppConfig,
  ) {
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    // @ts-ignore
    this.panorama = new google.maps.StreetViewPanorama(this.viewContainer.nativeElement, {
      pano: this.data.location.pano,
      linksControl: true,
      panControl: false,
      zoomControl: false,
      fullscreenControl: false,
      enableCloseButton: false,
      addressControl: false
    });
  }

  imageToLink(id) {
    return `${ this.appConfig.getHost() }/api2/public/image?image_id=${ id }&dimension=250`;
  }

  addImage() {
    this.addImageChange.emit(this.state());
  }

  close() {
    const state = this.state();
    this.activeModal.close(state);
    this.closeChange.emit(state);
  }

  private state() {
    if ( this.panorama.getLocation() ) {
      const location = this.panorama.getLocation().latLng;
      const pano = this.panorama.getPano();
      const pov = this.panorama.getPov();
      return new StreetViewModalState(location, pano, pov);
    }
    else {
      return null;
    }
  }
}
